/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // namespace
        window.Components = window.Components || {};

        // Breakpoint
        window.bp = new Breakpoint();

        window.cache = {
          $window: $(window),
          $document: $(document),
          $body: $('body'),
          $scrollDownButton: $('.js-scroll-down'),
          isMute: true,
        };


        // Modernizr example
        if (!Modernizr.touchevents) {
          console.log('notouch');
        } else {
          console.log('touch');
        }

        // jQuery Validate
        $('.js-form-validate').validate();

        // Link page with anchor
        var windowUrl = window.location.href;
        if(windowUrl.indexOf('#') > -1) {
          var anchor = windowUrl.split('#').pop();
          var href = '#' + anchor;
          var scrollTop = $(href).offset().top;

          $('html, body').animate({ scrollTop: scrollTop}, 800);
        }

        //---------
        // Init components
        //---------
        var $components = $("[data-component]");
        $components.each(function(index){
          var $el = $(this);
          var comp = $el.data('component');
          
          //Check if component exist
          if(typeof window.Components[comp] !== 'function') { 
            return;
          }
          
          // Component instantiation
          var obj = new window.Components[comp]($el);
          // Store instance in data
          $el.data('comp', obj);
        });

        //---------
        // Header
        //---------
        var $header = $('[data-module="header"]');
        if ($header.length > 0) {
          new Header({
            $el: $header
          });
        }

        //---------
        // Form Label
        //---------
        var $formField = $('.js-form-field'),
            $formBox;
        if ($formField.length > 0) {
          $formField.focus(function(){
            $formBox = $(this).closest('.js-form-box');

            $formBox.addClass('is-focus');
          }).focusout(function() {
            if ($(this).val() === '') {
              $formBox.removeClass('is-focus');
            }
          });
        }


        //---------
        // Challenge page
        //---------
        var challenge = $('[data-module="challenge"]');
        if (challenge.length > 0) {
          new Challenge({
            $el: challenge
          });
        }


        //---------
        // Projects page
        //---------
        var projects = $('[data-module="projects"]');
        if (projects.length > 0) {
          new Projects({
            $el: projects
          });
        }

        //---------
        // Slides Parallax
        //---------
        var slideParallax = $('[data-module="slideParallax"]');
        if (slideParallax.length > 0) {
          new SlideParallax({
            $el: slideParallax
          });
        }

        //-- Scroll down arrow
        window.cache.$scrollDownButton.on('click', function(){
          var windowHeight = window.cache.$window.height();
          $('html, body').stop().animate({ scrollTop: windowHeight }, 600);
        });



        //---------
        // Activate link on division
        //---------
        $('.js-block-link').on('click', function(e) {
          e.preventDefault();

          window.location = $(this).find('a').attr('href');
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Trigger open animations
        window.cache.$body.data('comp').playAnimation();
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
